import { createApp } from "vue";
import App from "./App.vue";
import { router } from './router';
import store from "./store";
import "./assets/tailwind.css";

router.beforeEach((to, from, next) => {
    store.dispatch('startLoading');  // Iniciar el preloader
    next();
  });
  
router.afterEach(() => {
    store.dispatch('stopLoading');  // Detener el preloader
});

createApp(App)
    .use(store).use(router).mount("#app");
